import { makeStyles } from '@material-ui/core/styles';

import { SizeDimention } from '../../models/models';

const useStyles = makeStyles({
  spaceAsset: {
    margin: '16px 0px 16px 16px',
  },
  staticValues: {
    lineHeight: 1.35,
    overflowWrap: 'anywhere',
  },
  filesStyle: {
    margin: '0px 10px 10px 0px',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    overflowWrap: 'anywhere',
  },
  downloadIcon: {
    marginRight: '4px',
    marginBottom: 'auto',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  flexColumn: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  labelStyle: {
    fontStyle: 'normal',
    lineHeight: 1.35,
  },
  entityGrid: {
    padding: '3px 16px',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0px',
  },
  verticalStyle: {
    padding: '3px 16px 6px',
  },
  verticalStyleColumn2: {
    padding: '6px 16px 3px',
    marginTop: 1,
  },

  tooltipLocation: {
    flexFlow: 'wrap',
    backgroundColor: '#212121',
    pointerEvents: 'auto',
    overflowY: 'auto',
    maxHeight: '300px',
    margin: '8px 0px',
  },
  chipGrid: {
    margin: '0px 8px 8px 0px',
    '& .locationButton': {
      borderRadius: '27px',
      color: '#6CD9C7',
      height: '32px',
      border: '1px solid',
      width: 'fit-content',
      backgroundColor: 'rgba(39, 126, 126, 0.10)',
      fontSize: '14px',
    },
  },
  assetIdText: {
    lineHeight: 1.35,
  },
  infoFeather: {
    width: 16.67,
    height: 16.67,
    marginLeft: 5.67,
  },
  assetName: {
    padding: '6px 16px 3px 16px',
    display: 'flex',
    flexDirection: 'row',
    marginTop: 1,
    borderRadius: '0px',
  },
  assetfileName: {
    lineHeight: 1.35,
    justifyContent: 'space-between',
    display: 'inline',
  },
  displayToolTip: {
    display: 'contents',
  },
  tooltip: {
    alignSelf: 'center',
  },
  seeMoreText: {
    display: 'inline-block',
    cursor: 'pointer',
  },
  assetPropertyText: {
    lineHeight: 1.35,
    overflowWrap: 'anywhere',
    fontStyle: 'normal',
  },
  commentsGrid: {
    padding: '3px 16px 6px 16px',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0px',
  },
  mainGrid: {
    display: (props: SizeDimention) =>
      props?.size?.height > props?.size?.width ? 'inline' : 'flex',
    flexDirection: 'row',
  },
});

export default useStyles;
